import {
  Booking,
  BookingStatus,
  RecurringPattern,
  Amenity,
  AmenityType,
} from '../models/booking.model';

export const MOCK_AMENITIES: Amenity[] = [
  {
    id: 1,
    nameKey: 'bookings.swimming-pool',
    name: 'bookings.swimming-pool',
    descriptionKey: 'bookings.swimming-pool-description',
    description: 'bookings.swimming-pool-description',
    type: AmenityType.POOL,
    capacity: 20,
    hourlyRate: 0,
    currency: 'USD',
    isActive: true,
    locationKey: 'bookings.ground-floor-outdoor',
    location: 'bookings.ground-floor-outdoor',
    amenities: ['Pool', 'Deck', 'Lounge Chairs', 'Shower'],
  },
  {
    id: 2,
    nameKey: 'bookings.fitness-center',
    name: 'bookings.fitness-center',
    descriptionKey: 'bookings.fitness-center-description',
    description: 'bookings.fitness-center-description',
    type: AmenityType.GYM,
    capacity: 15,
    hourlyRate: 0,
    currency: 'USD',
    isActive: true,
    locationKey: 'bookings.first-floor-indoor',
    location: 'bookings.first-floor-indoor',
    amenities: ['Treadmills', 'Weights', 'Yoga Mats', 'Mirrors'],
  },
  {
    id: 3,
    nameKey: 'bookings.conference-room-a',
    name: 'bookings.conference-room-a',
    descriptionKey: 'bookings.conference-room-a-description',
    description: 'bookings.conference-room-a-description',
    type: AmenityType.CONFERENCE_ROOM,
    capacity: 12,
    hourlyRate: 25.0,
    currency: 'USD',
    isActive: true,
    locationKey: 'bookings.second-floor-indoor',
    location: 'bookings.second-floor-indoor',
    amenities: ['Projector', 'Whiteboard', 'Video Conferencing', 'Coffee Station'],
  },
];

export const MOCK_BOOKINGS: Booking[] = [
  {
    id: 1,
    amenityId: 1,
    residentId: 1,
    titleKey: 'bookings.pool-party',
    title: 'bookings.pool-party',
    descriptionKey: 'bookings.pool-party-description',
    description: 'bookings.pool-party-description',
    startDate: new Date('2024-02-15T00:00:00Z'),
    endDate: new Date('2024-02-15T00:00:00Z'),
    startTime: new Date('2024-02-15T14:00:00Z'),
    endTime: new Date('2024-02-15T18:00:00Z'),
    status: BookingStatus.CONFIRMED,
    createdDate: new Date('2024-01-10T10:00:00Z'),
    updatedDate: new Date('2024-01-10T10:00:00Z'),
    totalCost: 0,
    currency: 'USD',
    specialRequestsKey: 'bookings.pool-party-special-requests',
    specialRequests: 'bookings.pool-party-special-requests',
    recurringPattern: RecurringPattern.NONE,
    isRecurring: false,
    maxParticipants: 15,
    currentParticipants: 12,
  },
  {
    id: 2,
    amenityId: 2,
    residentId: 2,
    titleKey: 'bookings.morning-workout',
    title: 'bookings.morning-workout',
    descriptionKey: 'bookings.morning-workout-description',
    description: 'bookings.morning-workout-description',
    startDate: new Date('2024-01-20T00:00:00Z'),
    endDate: new Date('2024-01-20T00:00:00Z'),
    startTime: new Date('2024-01-20T06:00:00Z'),
    endTime: new Date('2024-01-20T08:00:00Z'),
    status: BookingStatus.PENDING,
    createdDate: new Date('2024-01-18T15:30:00Z'),
    updatedDate: new Date('2024-01-18T15:30:00Z'),
    totalCost: 0,
    currency: 'USD',
    specialRequestsKey: 'bookings.morning-workout-special-requests',
    specialRequests: 'bookings.morning-workout-special-requests',
    recurringPattern: RecurringPattern.WEEKLY,
    isRecurring: true,
    maxParticipants: 1,
    currentParticipants: 1,
  },
  {
    id: 3,
    amenityId: 3,
    residentId: 3,
    titleKey: 'bookings.team-meeting',
    title: 'bookings.team-meeting',
    descriptionKey: 'bookings.team-meeting-description',
    description: 'bookings.team-meeting-description',
    startDate: new Date('2024-01-25T00:00:00Z'),
    endDate: new Date('2024-01-25T00:00:00Z'),
    startTime: new Date('2024-01-25T10:00:00Z'),
    endTime: new Date('2024-01-25T11:30:00Z'),
    status: BookingStatus.COMPLETED,
    createdDate: new Date('2024-01-20T09:00:00Z'),
    updatedDate: new Date('2024-01-25T11:30:00Z'),
    totalCost: 37.5,
    currency: 'USD',
    specialRequestsKey: 'bookings.team-meeting-special-requests',
    specialRequests: 'bookings.team-meeting-special-requests',
    recurringPattern: RecurringPattern.MONTHLY,
    isRecurring: true,
    maxParticipants: 8,
    currentParticipants: 8,
  },
  {
    id: 4,
    amenityId: 1,
    residentId: 4,
    titleKey: 'bookings.swimming-lesson',
    title: 'bookings.swimming-lesson',
    descriptionKey: 'bookings.swimming-lesson-description',
    description: 'bookings.swimming-lesson-description',
    startDate: new Date('2024-02-01T00:00:00Z'),
    endDate: new Date('2024-02-01T00:00:00Z'),
    startTime: new Date('2024-02-01T16:00:00Z'),
    endTime: new Date('2024-02-01T17:00:00Z'),
    status: BookingStatus.CANCELLED,
    createdDate: new Date('2024-01-22T14:15:00Z'),
    updatedDate: new Date('2024-01-30T10:00:00Z'),
    totalCost: 0,
    currency: 'USD',
    specialRequestsKey: 'bookings.swimming-lesson-special-requests',
    specialRequests: 'bookings.swimming-lesson-special-requests',
    recurringPattern: RecurringPattern.NONE,
    isRecurring: false,
    maxParticipants: 2,
    currentParticipants: 0,
  },
  {
    id: 5,
    amenityId: 2,
    residentId: 5,
    titleKey: 'bookings.evening-yoga-session',
    title: 'bookings.evening-yoga-session',
    descriptionKey: 'bookings.evening-yoga-session-description',
    description: 'bookings.evening-yoga-session-description',
    startDate: new Date('2024-02-05T00:00:00Z'),
    endDate: new Date('2024-02-05T00:00:00Z'),
    startTime: new Date('2024-02-05T19:00:00Z'),
    endTime: new Date('2024-02-05T20:30:00Z'),
    status: BookingStatus.NO_SHOW,
    createdDate: new Date('2024-01-28T11:45:00Z'),
    updatedDate: new Date('2024-02-05T20:30:00Z'),
    totalCost: 0,
    currency: 'USD',
    specialRequestsKey: 'bookings.evening-yoga-session-special-requests',
    specialRequests: 'bookings.evening-yoga-session-special-requests',
    recurringPattern: RecurringPattern.NONE,
    isRecurring: false,
    maxParticipants: 1,
    currentParticipants: 0,
  },
];
